export type Review = {
  quote: string
  name: string
  role?: string
  city?: string
  country?: string
}

/**
 * Reseñas de compradores de Vivencia Ready. Con el array vacío la sección
 * no se muestra. Cargar solo reseñas reales.
 */
export const reviews: Review[] = [
  {
    quote:
      'I used to spend my evenings piecing together activities, then second-guess everything before class. With Vivencia Ready, I open a plan and I’m grounded immediately. My students tell me the pacing feels “just right,” and I finally feel like I’m leading with confidence instead of stress.',
    name: 'Jessica Miller',
  },
  {
    quote:
      'The Rise-Deepen-Return structure is exactly what I needed. I love the gentle and full options because mixed groups used to challenge me. Now the energy flows naturally, and the music tempo guidance saves me so much time selecting tracks.',
    name: 'Michael Chen',
  },
  {
    quote:
      'I bought Vivencia Ready for weekly classes, but I ended up using the workshop and retreat plans right away. The sessions feel cohesive and intentional. It’s like having a mentor in my pocket—my group keeps showing up, and so do I.',
    name: 'Ashley Johnson',
  },
]
